export default __webpack_public_path__ + "static/video-instructions-fa3da3b7495b961b09c8d2cc070acc76.png";